(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sku"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__skuSwitcher) return;
    window.__skuSwitcher = true;

    function setSku(comp, sku) {
      var target = comp.firstElementChild || comp;
      target.textContent = sku || '';
      comp.style.display = sku ? 'block' : 'none';
    }

    function findVariant(list, el) {
      var val = String(el.value || '');
      var v = list.find(function (x) { return String(x.id) === val; });
      if (v) return v;
      if (el.tagName === 'SELECT' && el.selectedIndex > -1) {
        var text = el.options[el.selectedIndex].text.split(/\s[—–-]\s/)[0].trim().toLowerCase();
        v = list.find(function (x) { return String(x.title).trim().toLowerCase() === text; });
      }
      return v;
    }

    document.addEventListener('change', function (e) {
      var el = e.target;
      if (!el.matches || !el.matches('select, input[name="id"]')) return;
      var node = el.parentElement;
      while (node && node !== document.body) {
        var comps = node.querySelectorAll('product-sku-component');
        if (comps.length > 1) return;
        if (comps.length === 1) {
          var comp = comps[0];
          var data = comp.nextElementSibling;
          if (!data || !data.hasAttribute('data-sku-variants')) return;
          var list;
          try { list = JSON.parse(data.textContent); } catch (err) { return; }
          var v = findVariant(list, el);
          if (v) setSku(comp, v.sku);
          return;
        }
        node = node.parentElement;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
